import React from 'react';
import Button from '@bbkPricingPage/components/button/pricing-card-button';
import {
  getSubscribedCTAText,
  isCTADisabled,
} from '@bbkPricingPage/helpers/pricing-table-helper';
import {
  SubscriberCTAAction,
  type ActionButton,
  type PaywallConfig,
  type Price,
  type QuantityMeta,
} from '@bbkPricingPage/types/pricing-table-types';

export type CTAButtonProps = {
  itemId: string;
  price: Price;
  actionButton?: ActionButton;
  isSubscribedPrice?: boolean;
  paywallConfig?: PaywallConfig;
  quantity: number | undefined;
  subscriptionQuantity: number | undefined;
  subscriptionStatus?: string;
  hasChanges?: boolean;
  quantityMeta?: QuantityMeta;
  disabled?: boolean;
  onClick: () => void;
};

export const CTAButton = ({
  itemId,
  price,
  actionButton,
  isSubscribedPrice,
  paywallConfig,
  quantity = 1,
  subscriptionQuantity = 1,
  subscriptionStatus,
  hasChanges,
  quantityMeta,
  disabled = false,
  onClick,
}: CTAButtonProps) => {
  quantity = quantity ?? 1;
  subscriptionQuantity = subscriptionQuantity ?? 1;

  const subscribedPlanCtaText = getSubscribedCTAText(
    paywallConfig?.action_button?.text,
    subscriptionStatus
  );
  const subscriberCTAAction =
    paywallConfig?.action_button?.action ?? SubscriberCTAAction.do_nothing;

  const isDisabled = isCTADisabled(
    subscriptionStatus,
    subscriptionQuantity,
    isSubscribedPrice as boolean,
    subscriberCTAAction,
    quantity,
    !!hasChanges,
    price,
    quantityMeta
  );

  const handleOnClick = () => {
    onClick();
  };

  let buttonText;
  if (isSubscribedPrice) {
    buttonText = subscribedPlanCtaText ?? "You're currently on this plan!";
  } else {
    buttonText = actionButton?.text ?? 'Choose plan';
  }

  return (
    <Button
      id={`item-actionButton-${itemId}`}
      variant="brand"
      className="tw-mt-2 tw-block tw-min-h-full tw-w-full tw-py-2 disabled:tw-bg-[color-mix(in_srgb,var(--pricing-page-button-bg-color)_20%,transparent)]"
      trackId="button.checkout"
      trackPayload={(actionButton ?? {}) as Record<string, unknown>}
      onClick={handleOnClick}
      disabled={isDisabled || disabled}
    >
      {buttonText}
    </Button>
  );
};
